import { parseJwt } from '~/helpers/decodeToken.helper';

let accessTokenValue = '';

export const accessToken = {
  get: () => accessTokenValue,
  getDecoded: () => parseJwt(accessTokenValue),
  set: (value: string) => {
    accessTokenValue = value;
  },
};

export const TOKEN = {
  EMAIL: 'https://mypages/email',
  SSN: 'https://mypages/ssn',
  MARKET: 'https://mypages/market',
  CLIENT_ID: 'https://onboarding/clientId',
  USER_CODE: 'https://onboarding/userCode',
  DATE_OF_BIRTH: 'https://onboarding/dateOfBirth',
};
